import React, { useState } from "react";
import { checkValueIsPositiveDecimal } from "../../../utils/constants";
import SelectWithSearchBox from "../../../pages/townson-dashboard-list/components/client-data-upload-component/select-with-search-box";
import InputText from "../../InputText/InputText";
import InputCheckbox from "../../InputCheckbox/InputCheckbox";
import InputSelect from "../../InputSelect/InputSelect";
import InputTextarea from "../../InputTextArea/InputTextArea";
import {
	handleMonetaryChange,
	formatMonetaryValue,
	validateCoordinate,
	formatOnBlur,
} from "../CreateCloneBusinessInsightsDashboard.helper";

import { addCommas } from "../../../helper/number.helpers";
import InputToggle from "../../InputToggle/InputToggle";

function GeneralLocationFields({
	handleBlur,
	handleFocus,
	maxLengthTextArea,
	location,
	locationDescription,
	handleOnDiscriptionChange,
	index,
	handleOnAddressChange,
	hideLocation = false,
}) {
	const getFieldValue = (fieldName) => {
		if (!locationDescription[index]) return "";
		return locationDescription[index][fieldName] || "";
	};
	const [allowCoordinates, setAllowCoordinates] = useState(false);
	const statusOptions = [
		{ value: "Existing", label: "Existing" },
		{ value: "Under Construction", label: "Under Construction" },
		{ value: "Proposed", label: "Proposed" },
	];

	const formatMonetaryDisplay = (value) => {
		if (!value && value !== 0) return "";
		return `$${addCommas(formatMonetaryValue(value))}`;
	};

	React.useEffect(() => {
		if (
			location.proposedLocations[index]?.position?.lat &&
			location.proposedLocations[index]?.position?.lon &&
			!location.proposedLocations[index]?.address?.freeformAddress
		) {
			setAllowCoordinates(true);
		}
	}, [location.proposedLocations, index]);

	return (
		<>
			{!hideLocation && (
				<>
					<InputToggle
						onValueChange={(e) => {
							setAllowCoordinates(!allowCoordinates);
						}}
						isChecked={allowCoordinates}
						label='Use lat/long'
					/>
					{allowCoordinates ? (
						<div className='d-flex' style={{ gap: "30px" }}>
							<div className='w-100'>
								<InputText
									label='Latitude'
									type='number'
									step='any'
									value={location.proposedLocations[index]?.position?.lat || ""}
									onValueChange={(value) => {
										const validValue = validateCoordinate(value, "lat");
										const updatedPosition = {
											...location.proposedLocations[index]?.position,
											lat: validValue,
											is_current:
												location.proposedLocations[index]?.position?.is_current || false,
										};

										const lon = location.proposedLocations[index]?.position?.lon || "";
										const coordsTitle = validValue && lon ? `${validValue},${lon}` : "";

										handleOnAddressChange(
											{
												...location.proposedLocations[index],
												position: updatedPosition,
												address: { freeformAddress: "" },
												lat_lng_title: coordsTitle,
											},
											"proposedLocations",
											index,
										);
									}}
								/>
							</div>
							<div className='w-100'>
								<InputText
									label='Longitude'
									type='number'
									step='any'
									value={location.proposedLocations[index]?.position?.lon || ""}
									onValueChange={(value) => {
										const validValue = validateCoordinate(value, "lon");
										const updatedPosition = {
											...location.proposedLocations[index]?.position,
											lon: validValue,
											is_current:
												location.proposedLocations[index]?.position?.is_current || false,
										};

										const lat = location.proposedLocations[index]?.position?.lat || "";
										const coordsTitle = lat && validValue ? `${lat},${validValue}` : "";

										handleOnAddressChange(
											{
												...location.proposedLocations[index],
												position: updatedPosition,
												address: { freeformAddress: "" },
												lat_lng_title: coordsTitle,
											},
											"proposedLocations",
											index,
										);
									}}
								/>
							</div>
						</div>
					) : (
						<SelectWithSearchBox
							selectedProposedLocation={location.proposedLocations}
							setSelectedItem={(e) => {
								handleOnAddressChange(e, "proposedLocations", index);
							}}
							key={index}
							index={index}
							lableName='Location address'
						/>
					)}
				</>
			)}
			<div className='is_current'>
				<InputCheckbox
					label='Is a Current Location?'
					name='is_current'
					isChecked={locationDescription[index]?.is_current || false}
					onValueChange={(checked) => {
						handleOnDiscriptionChange("is_current", checked, index);
					}}
				/>
			</div>
			<InputSelect
				id='status'
				label='Select Status'
				value={locationDescription[index]?.status || ""}
				onValueChange={(value) => {
					handleOnDiscriptionChange("status", value, index);
				}}
				options={[
					{ value: "Existing", label: "Existing" },
					{ value: "Under Construction", label: "Under Construction" },
					{ value: "Proposed", label: "Proposed" },
				]}
				theme='default'
				size='md'
				required={false}
				allowNull={true}
				nullOptionText='Choose Status'
				invalid={false}
				disabled={false}
			/>
			<InputText
				className={locationDescription[index]?.base_rent ? "hasFocus" : ""}
				type='text'
				name='base_rent'
				label='Base Rent'
				onFocus={() => {
					handleFocus({ target: { name: "base_rent" } });
				}}
				onBlur={() => {
					handleBlur({ target: { name: "base_rent" } });
					const currentValue = locationDescription[index]?.base_rent;
					if (currentValue) {
						const formattedValue = formatOnBlur(currentValue);
						handleOnDiscriptionChange("base_rent", formattedValue, index);
					}
				}}
				value={
					document.activeElement === document.getElementById(`base_rent-${index}`)
						? locationDescription[index]?.base_rent || ""
						: formatMonetaryDisplay(locationDescription[index]?.base_rent)
				}
				onValueChange={(value) => handleMonetaryChange(value, index, handleOnDiscriptionChange, "base_rent")}
				id={`base_rent-${index}`}
			/>
			<InputText
				className={locationDescription[index]?.opex_value ? "hasFocus" : ""}
				type='text'
				name='opex_value'
				label='Operating Expenses (Annually)'
				onFocus={() => {
					handleFocus({ target: { name: "opex_value" } });
				}}
				onBlur={() => {
					handleBlur({ target: { name: "opex_value" } });
					const currentValue = locationDescription[index]?.opex_value;
					if (currentValue) {
						const formattedValue = formatOnBlur(currentValue);
						handleOnDiscriptionChange("opex_value", formattedValue, index);
					}
				}}
				value={
					document.activeElement === document.getElementById(`opex_value-${index}`)
						? locationDescription[index]?.opex_value || ""
						: formatMonetaryDisplay(locationDescription[index]?.opex_value)
				}
				onValueChange={(value) => handleMonetaryChange(value, index, handleOnDiscriptionChange, "opex_value")}
				id={`opex_value-${index}`}
			/>
			<InputText
				className={locationDescription[index]?.gross_price_sf ? "hasFocus" : ""}
				type='text'
				name='gross_price_sf'
				label='Gross PSF'
				onFocus={() => {
					handleFocus({ target: { name: "gross_price_sf" } });
				}}
				onBlur={() => {
					handleBlur({ target: { name: "gross_price_sf" } });
					const currentValue = locationDescription[index]?.gross_price_sf;
					if (currentValue) {
						const formattedValue = formatOnBlur(currentValue);
						handleOnDiscriptionChange("gross_price_sf", formattedValue, index);
					}
				}}
				value={
					document.activeElement === document.getElementById(`gross_price_sf-${index}`)
						? locationDescription[index]?.gross_price_sf || ""
						: formatMonetaryDisplay(locationDescription[index]?.gross_price_sf)
				}
				onValueChange={(value) =>
					handleMonetaryChange(value, index, handleOnDiscriptionChange, "gross_price_sf")
				}
				id={`gross_price_sf-${index}`}
			/>
			<InputText
				className={locationDescription[index]?.leasing_company ? "hasFocus" : ""}
				type='text'
				name='leasing_company'
				label='Leasing Company Name'
				onFocus={() => handleFocus({ target: { name: "leasing_company" } })}
				onBlur={() => handleBlur({ target: { name: "leasing_company" } })}
				value={getFieldValue("leasing_company")}
				onValueChange={(value) => handleOnDiscriptionChange("leasing_company", value, index)}
			/>
			<InputTextarea
				name='notes'
				label='Notes'
				id={`notes-${index}`}
				value={getFieldValue("notes")}
				maxLength={maxLengthTextArea}
				onValueChange={(value) => {
					handleOnDiscriptionChange("notes", value, index);
				}}
			/>
		</>
	);
}

export default GeneralLocationFields;
